import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as API from "../../libs/service";

import routes from "../../libs/routes";
// import consts from '../../libs/consts';

import { logIn, logOut } from "../../redux/usersSlice";
import { open, close } from "../../redux/popupSlice";
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";

import Popup01 from "../popup/Popup01";

import { numFormat } from "../../libs/utils";

export default function PopupPlanModel(props) {
    const { 
        title,
        subTitle,
        text, 
        lefttext,
        width, 
        button, 
        buttonCancel, 
        func, 
        setFunc, 
        noneLoading, 
        top,
        cancelFunc,
        x_btn,
        cancelText,
        longButton,
        text1,
        text2,
        text3,
        text1_b,
        text2_b,
        text3_b,
        max_width,
        plan_type,
        free_plan, // 무료 이용 유무
        free_text, // 무료 이용일때 출력 텍스트
        pay_card, // 등록된 결제 카드가 있을때
        useCoupon, // 구매 내역 페이지에서 쿠폰 사용 *현재 사용안함
        member, // Team 이거나 Classroom 모델이면 멤버 수 표기 *현재 사용안함
        plan_plus, // Team, Classroom 모델에서 라이선스 추가시, *현재 사용안함
        couponSale, // 쿠폰 페이지에서 선결제 
        licensePlus, // 라이선스 페이지에서 추가 구매
        saleService,
        mainCard={},
        nocardbuttonType='',
        payData=()=>{},
        seetnotviewer=false,
        priceProMonth = 0,
        priceProYear = 0,
        invoiceCode='',
        showWon=true,
        couponlists=[],
        PriceProYearsale=0
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const [maxWidthCut, setMaxWidthCut] = useState(max_width);

    const [couponErr, setCouponErr] = useState(0);
    const [stepPayPopup, setStepPayPopup] = useState(1);
    const [planPopRadioValue, setPlanPopRadioValue] = useState(1);
    const [couponDrop, setCouponDrop] = useState(false);
    //const coupon_sample = ['쿠폰1', '쿠폰2', '쿠폰3', '쿠폰4', '쿠폰5', '쿠폰6'];
    const coupon_sample = [];
    const coupon_default = lang === 0 ? '쿠폰을 선택해 주세요.' : 'Please select a coupon.';
    const coupon_input = lang === 0 ? '직접 쿠폰 등록' : 'Register Coupon Manually';
    const coupon_none = lang === 0 ? '쿠폰 사용 안함' : 'Do not use coupon';
    const [couponSelect, setCouponSelect] = useState(coupon_default);
    const [couponInputValue, setCouponInputValue] = useState('');
    const [couponInputState, setConponInputState] = useState(2);

    const notUseCoupon = couponSelect === coupon_default || couponSelect === coupon_none;
    const couponInput = couponSelect === coupon_input;

    const [inputErr, setInputErr] = useState(0);
    const [noneInput, setNoneInput] = useState(false);

    const [proMonth, setProMonth] = useState(priceProMonth);
    const [proYear, setProYear] = useState(priceProYear);
    const [proYearMonth, setProYearMonth] = useState(priceProMonth);

    const [sheetValue, setSheetValue] = useState(1);
    const [discounts, setdiscounts] = useState(0);

    // 쿠폰 페이지에서 선결제 기능
    const [myModelDrop, setMyModelDrop] = useState(false);
    const [myModelSelect, setMyModelSelect] = useState('UModeler X Pro');
    const [myModelValue, setMyModelValue] = useState(2);
    const my_model_sample = ['UModeler X Pro', 'UModeler X Art Pass', 'UModeler X All-In-One'];

    /* console.log(couponInputState, '2가 아니면 통과불가'); */
    //alert(priceProYear);
    useEffect(() => {
        setProMonth(priceProMonth);
        setProYear(invoiceCode !== '' ? (priceProYear*0.5).toFixed(2) : priceProYear);
    }, [priceProMonth, priceProYear, invoiceCode]);

    useEffect(() => {
        
        if(couponInputState*1 === 2 && (couponlists?.find(item => item?.couponCode === couponSelect)?.discount || couponlists?.find(item => item?.couponCode === couponInputValue)?.discount)){
            let discount = couponlists?.find(item => item?.couponCode === couponSelect)?.discount || couponlists?.find(item => item?.couponCode === couponInputValue)?.discount;
            setdiscounts(discount);
        }
        
    }, [couponSelect, couponInputState]);

    
    useEffect(() => {
        if (!buttonCancel && !button && top) {
            const popup = document.querySelector(".popup.show");
            /* console.log(popup); */
            if (popup) popup.classList.add("popup_top");
            const timeout = setTimeout(() => {
                dispatch(close());
            }, 1000);
            popup.addEventListener("click", () => {
                dispatch(close());
                clearTimeout(timeout);
            });
        }
    }, []);

    useEffect(() => {
        if(!couponInput) {
            setCouponInputValue('');
        }
    }, [couponSelect]);

    useEffect(() => {
        if(saleService) {
            setPlanPopRadioValue(2);
        }
    }, []);

    const setFunction = () => {
        if(setFunc) setFunc();
        dispatch(close());
    };

    const checkboxFunc = (value) => {
        setPlanPopRadioValue(value)
        if(value === 2){
            setConponInputState(0);
        } else {
            setCouponSelect(lang === 0 ? '쿠폰을 선택해 주세요.' : 'Please select a coupon.');
            setCouponErr(0);
            setConponInputState(2);
        }
    };

    const numberInput = (e) => {
        const { name, value } = e.target;

        if(name === "model_people") {
            let numValue = value.replace(/[^0-9]/g, '');
            e.target.value = numValue;

            if (numValue === "0") {
                numValue = "";
            } else {
                numValue = numValue.replace(/^0+/, ''); 
            }

            if(!numValue) {
                setNoneInput(false)
            } else {
                setNoneInput(true)
                setInputErr(0)
            }
        }

        if(name === "sheetnum") {
            let numValue = value.replace(/[^0-9]/g, '');
            e.target.value = numValue;

            if (numValue === "0") {
                numValue = "";
            } else {
                numValue = numValue.replace(/^0+/, ''); 
            }

            if(!numValue) {
                setSheetValue("");
                setNoneInput(false);
            } else {
                setSheetValue(numValue);
                setNoneInput(true);
                setInputErr(0);
            }
        }

        if(name === "couponinput") {
            e.target.value = value;

            if(!value) {
                setCouponInputValue("");
            } else {
                setCouponInputValue(value);
            }
        }

        if(name === "member_plus") {
            let numValue = value.replace(/[^0-9]/g, '');
            e.target.value = numValue;

            if (numValue === "0") {
                numValue = "";
            } else {
                numValue = numValue.replace(/^0+/, ''); 
            }

            if(!numValue) {
                setMyModelValue("");
                setNoneInput(false);
            } else {
                setMyModelValue(numValue);
                setNoneInput(true);
                setInputErr(0);
            }
        }
    };

    console.log(couponInputState);

    const payOk = async() => {
        // console.log(proMonth);
        // console.log(proYear);
        // console.log(planPopRadioValue); //1월 2년
        //쿠폰금액 추가해야함
        dispatch(loadingStart());

        let sender = {
            idx: mbData?.idx,
            cardIdx: mainCard?.idx,
            proMonth: proMonth, //월 금액
            proYear: proYear, //년 금액
            planPopRadioValue: planPopRadioValue, //1: 월 2: 년
            couponPrice: 0, //쿠폰금액 추가해야함
            plan: plan_type, //'Pro', 'Art Pass', 'All-In-One'
            invoiceCode: invoiceCode, //인보이스코드
            showWon: showWon ? 'KRW' : 'USD',
            couponCode: couponSelect || couponInputValue
        }
        const result = await API.xsollaApis("user/XsolaApipayMent", sender);
        dispatch(open({
            component: 
                <Popup01
                    max_width={'300px'}
                    x_btn={false}
                    text1={
                        result?.message === '회원정보가 없습니다.' ? lang === 0 ? result?.message : 'No member information found.' :
                            result?.message === '등록된 카드가 없습니다.' ? lang === 0 ? result?.message : 'No registered card found.' : 
                                result?.message === '등록된 결제 수단이 없습니다.' ? lang === 0 ? result?.message : 'No registered payment method found.' : 
                                    result?.message === '사용할 수 없는 카드입니다.' ? lang === 0 ? result?.message : 'This card cannot be used.' :
                                        result?.message === '구독이 시작되었습니다.' ? lang === 0 ? result?.message : 'Your subscription has been started.' : ''
                    }
                    longButton={'확인'}
                />
        }));

        if(result?.status === 200){
            //완료 함수 적용
            payData(invoiceCode);
        }
        dispatch(loadingEnd());
    }

    return (
        <>
            <div 
                className={`popup_default01 plan_model ${stepPayPopup != 3 && 'mobile_width'} ${lang === 0 ? '' : 'en'}`} 
                style={{ 
                    maxWidth: lang !== 0 ? 550 : max_width ? maxWidthCut : '400px', 
                    width: '100%', 
                    marginLeft: 10, 
                    marginRight: 10,
                }}
                >
                {x_btn &&
                    <div 
                        className="popup_x_btn_box"
                        style={{
                            
                        }}
                    >
                        <img src={require("../../assets/images/exit-icon.svg").default} 
                            className="popup_x_btn" 
                            onClick={() => {
                                dispatch(close());
                            }}
                            style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                        />
                        :
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: 'rgba(0, 0, 0, 0.50)',
                                borderRadius: '100px',
                                margin: '12px 12px 0 0',
                                width: '32px',
                                height: '32px'
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                dispatch(close());
                            }}
                        >
                            <img src={require("../../assets/images/exit-icon-white.svg").default} 
                                className="popup_x_btn" 
                                style={{ 
                                    cursor: isBrowser ? 'pointer' : 'auto',
                                }}
                            />
                        </div>
                        <div style={{ height: 16 }} />
                    </div>
                }

                <div 
                    className={`popup_content_box plan_model ${stepPayPopup != 1 && 'step'} ${stepPayPopup === 3 && 'step3pop'}`}
                    style={{

                    }}
                >
                    
                {stepPayPopup == 1 &&
                    <>
                        {plan_type &&
                            <div className="title">
                                {plan_type == 'All-In-One' ?
                                    <p 
                                        className={`model ${plan_type == 'Pro' || plan_type == 'School' ? 'main' : 'sub'}`}
                                    >
                                        UModeler X {plan_type}
                                    </p>
                                    :
                                    <p 
                                        className={`model ${plan_type == 'Pro' || plan_type == 'School' ? 'main' : 'sub'}`}
                                    >
                                        UModeler X {plan_type}
                                    </p>
                                }
                                
                                <img src={require("../../assets/images/exit-icon.svg").default} 
                                    className="popup_x_btn" 
                                    onClick={() => {
                                        dispatch(close());
                                    }}
                                    style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                                />
                            </div>
                        }

                        {couponSale &&
                            <>
                                <div className="title coupon_sale">
                                    <div>
                                        <p>{lang === 0 ? '선결제(쿠폰 할인)' : 'Prepayment (Coupon Discount)'}</p>
                                        <span>
                                            {lang === 0 ? '구독 상품을 미리 결제하여 요금을 절감하세요.' : 'Prepay for your subscription and save on costs.'}
                                        </span>
                                    </div>
                                        
                                    <img src={require("../../assets/images/exit-icon.svg").default} 
                                        className="popup_x_btn" 
                                        onClick={() => {
                                            dispatch(close());
                                        }}
                                        style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                                    />
                                </div>
                            </>
                           
                        }

                        {/* {free_plan &&
                            <div className="free_comment">
                                <span>30일간 무료로 이용</span>가능하며<br />
                                무료 이용 기간중에는 언제든지 취소 가능합니다.
                            </div>
                        } */}
                        
                        {!saleService ?
                            <div className="pop_scroll_box">
                                {!useCoupon && !plan_plus &&
                                    <div className="price_option">
                                        <p className="title">{lang === 0 ? '청구 옵션' : 'Billing Options'}</p>

                                        <label className={`option_chk ${planPopRadioValue === 1 ? 'on' : ''}`} htmlFor="price_option1">
                                            <input 
                                                type="radio" 
                                                name="price_option" 
                                                id="price_option1"
                                                onChange={() => checkboxFunc(1)}
                                                checked={planPopRadioValue === 1}
                                            />

                                            <div className="price">
                                                <p>{lang === 0 ? '월간 결제' : 'Monthly Payment'}</p>
                                                <span><b>{(showWon ? '' : 'USD ')}{numFormat((proMonth).toFixed(2))}{showWon ? lang === 0 ? '원' : 'KRW' : ''}</b> / {lang === 0 ? '월' : 'Month'}</span>
                                            </div>

                                            {/* {couponInput ?
                                                <>
                                                    {couponInputState === 2 &&
                                                        <div className="sale">
                                                            {couponlists?.find(item => item?.couponCode === couponInputValue)?.discount}%
                                                            <img src={require("../../assets/icon/sale_arrow.svg").default} />
                                                        </div>
                                                    }
                                                </>
                                                :
                                                <>
                                                    {couponSelect !== coupon_default && couponSelect !== coupon_none &&
                                                        <div className="sale">
                                                            {couponlists?.find(item => item?.couponCode === couponInputValue)?.discount}%
                                                            <img src={require("../../assets/icon/sale_arrow.svg").default} />
                                                        </div>
                                                    }
                                                </>
                                            } */}
                                        </label>

                                        {/* <label className={`option_chk ${planPopRadioValue === 2 ? 'on' : ''}`} htmlFor="price_option2">
                                            <input 
                                                type="radio" 
                                                name="price_option" 
                                                id="price_option2"
                                                onChange={() => checkboxFunc(2)}
                                                checked={planPopRadioValue === 2}
                                            />
                                            <div className="price">
                                                <p>연간 결제(월 결제)</p>
                                                <span><b>16,000원</b> / 월</span>
                                            </div>

                                            {couponSelect !== coupon_default && couponSelect !== coupon_none &&
                                                <div className="sale">
                                                    {couponlists?.find(item => item?.couponCode === couponInputValue)?.discount}%
                                                    <img src={require("../../assets/icon/sale_arrow.svg").default} />
                                                </div>
                                            }
                                        </label> */}

                                        <label className={`option_chk ${planPopRadioValue === 2 ? 'on' : ''}`} htmlFor="price_option3">
                                            <input 
                                                type="radio" 
                                                name="price_option" 
                                                id="price_option3"
                                                onChange={() => checkboxFunc(2)}
                                                checked={planPopRadioValue === 2}
                                            />
                                            <div className="price">
                                                <p>{lang === 0 ? '연 구독' : 'Annual Payment'}</p>
                                                <span>
                                                    <b style={{ marginRight: 5}}>{(showWon ? '' : 'USD ')}{numFormat((proYear).toFixed(2))}{showWon ? lang === 0 ? '원' : 'KRW' : ''}</b> 
                                                    {/* {lang === 0 ? <>(월 기준 {(showWon ? '' : 'USD ')}{numFormat(lang === 0 ? proYearMonth : (proYear/12).toFixed(2))}{showWon ? lang === 0 ? '원' : 'KRW' : ''})</> : <>({(showWon ? '' : 'USD ')}{numFormat((proYear/12).toFixed(2))} per month)</>}</span> */}
                                                    {lang === 0 ? <>(월 기준 {(showWon ? '' : 'USD ')}{numFormat((proYear/12).toFixed(2))}{showWon ? lang === 0 ? '원' : 'KRW' : ''})</> : <>({(showWon ? '' : 'USD ')}{numFormat((proYear/12).toFixed(2))} per month)</>}</span>
                                            </div>
                                            {couponInput ?
                                                <>
                                                    {couponInputState === 2 &&
                                                        <div className="sale">
                                                            {couponlists?.find(item => item?.couponCode === couponInputValue)?.discount}%
                                                            <img src={require("../../assets/icon/sale_arrow.svg").default} />
                                                        </div>
                                                    }
                                                </>
                                                :
                                                <>
                                                    {couponSelect !== coupon_default && couponSelect !== coupon_none &&
                                                        <div className="sale">
                                                            {couponlists?.find(item => item?.couponCode === couponSelect)?.discount}%
                                                            <img src={require("../../assets/icon/sale_arrow.svg").default} />
                                                        </div>
                                                    }
                                                </>
                                            }
                                        </label>
                                    </div>
                                }

                                {(useCoupon || plan_plus) &&
                                    <>
                                        {/* <div className="my_plan_model">
                                            {lang === 0 ? '월간 결제' : 'Monthly Payment'}<br />
                                            <span>20,000원</span> / 월
                                        </div> */}
                                        <div className="poup_my_sub_model list price_option">
                                            <p className="title">{lang === 0 ? '구독 상품' : 'Subscription product'}</p>

                                            <div 
                                                className={`coupon_drop_box ${myModelDrop ? 'on' : ''}`}
                                                onClick={() => {
                                                    setMyModelDrop(!myModelDrop)
                                                }}
                                            >
                                                <p>
                                                    {myModelSelect}
                                                    <span> 2/sheet</span>
                                                </p>

                                                {myModelDrop &&
                                                    <div className="coupon_drop_list">
                                                        {my_model_sample.map((x, i) => (
                                                            <p 
                                                                key={i}
                                                                onClick={() => {
                                                                    setMyModelSelect(x);
                                                                    setCouponErr(0)
                                                                }}
                                                            >
                                                                {x}
                                                            </p>
                                                        ))}
                                                    </div> 
                                                }
                                            </div>
                                        </div>

                                        <div className="use_member_box plus_plan">
                                            <p>{lang === 0 ? '현재 멤버' : 'Current member'}</p>
                                            <span>{lang === 0 ? '2인' : '2 members'}</span>
                                        </div>

                                        <div className="use_member_box plus_plan plus">
                                            <p>{lang === 0 ? '추가할 멤버' : 'Additional member'}</p>
                                            <input 
                                                className="member_plus"
                                                type="text" 
                                                placeholder={lang === 0 ? '인원수' : 'Number of members'}
                                                maxLength={4}
                                                name="member_plus"
                                                onChange={numberInput}
                                                value={myModelValue}
                                            />
                                            <span>{lang === 0 ? '인' : 'member'}</span>
                                        </div>

                                        {inputErr == 1 && 
                                            <span 
                                                className="err_msg id" 
                                                style={{
                                                    marginTop: '-20px',
                                                    textAlign: 'right'
                                                }}
                                            >
                                                {lang === 0 ? '멤버를 입력해 주세요.' : 'Please enter a member.'}
                                            </span>
                                        }

                                        <div className="price_option">
                                            <p className="title">{lang === 0 ? '할인 적용' : 'Apply discount'}</p>

                                            <div 
                                                className={`coupon_drop_box ${couponDrop ? 'on' : ''}`}
                                                onClick={() => {
                                                    setCouponDrop(!couponDrop)
                                                }}
                                            >
                                                <p>{couponSelect}</p>

                                                {couponDrop &&
                                                    <div className="coupon_drop_list">
                                                        {/* <p
                                                            onClick={() => {
                                                                setCouponSelect(coupon_input);
                                                                setCouponErr(0)
                                                                setConponInputState(0);
                                                            }}
                                                        >
                                                            {coupon_input}
                                                        </p> */}
                                                        
                                                        {couponlists.map((x, i) => (
                                                            <p 
                                                                key={i}
                                                                onClick={() => {
                                                                    setCouponSelect(x?.couponCode);
                                                                    setCouponErr(0);
                                                                    setConponInputState(2);
                                                                }}
                                                            >
                                                                {x?.couponCode}
                                                            </p>
                                                        ))}
                                                    </div> 
                                                }
                                            </div>

                                            {/* {!notUseCoupon &&
                                                <div className="sale_comment">
                                                    3개월간 20% 할인 적용됩니다.
                                                </div>
                                            } */}

                                            {couponErr == 1 && <span className="err_msg id" style={{ marginTop: '-4px' }}>{lang === 0 ? '쿠폰을 선택해 주세요.' : 'Please select a coupon.'}</span>}

                                            {couponInput &&
                                                <>
                                                    <div className="coupon_input_box">
                                                        <input 
                                                            type="text"
                                                            className={`${couponInputState === 2 ? 'active' : ''}`}
                                                            name="couponinput"
                                                            placeholder={lang === 0 ? '쿠폰 코드 입력' : 'Enter coupon code.'}
                                                            maxLength={20}
                                                            onChange={numberInput}
                                                            value={couponInputValue}
                                                            readOnly={couponInputState === 2}
                                                        />
                                                        
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                if(!couponInputValue) {
                                                                    setConponInputState(1);
                                                                } else {
                                                                    setConponInputState(2);
                                                                }
                                                            }}
                                                        >
                                                            {lang === 0 ? '등록' : 'Register'}
                                                        </button>
                                                    </div>

                                                    {couponInputState == 1 && <span className="err_msg id" style={{ marginTop: '-4px' }}>{lang === 0 ? '유효한 쿠폰 코드가 아닙니다.' : 'Invalid coupon code.'}</span>}
                                                </>
                                            }
                                            {couponInputState == 2 && <span className="err_msg id" style={{ color: '#0E6AF4', marginTop: '-4px' }}>{lang === 0 ? `이용중이신 모든 월구독 상품에 ${couponlists?.find(item => item?.couponCode === couponInputValue)?.discount}% 할인 적용됩니다.` : `A ${couponlists?.find(item => item?.couponCode === couponInputValue)?.discount}% discount is applied to all your active monthly subscription products.`}</span>}
                                            {couponInputState == 4 && <span className="err_msg id" style={{ marginTop: '-4px' }}>{lang === 0 ? '쿠폰을 선택해 주세요.' : 'Please select a coupon.'}</span>}
                                        </div>
                                    </>
                                }

                                {licensePlus &&
                                    <>
                                        <div className="use_member_box plus_plan">
                                            <p>{lang === 0 ? '현재 멤버' : 'Current member'}</p>
                                            <span>{lang === 0 ? '2인' : '2 members'}</span>
                                        </div>

                                        <div className={`use_member_box ${plan_plus ? 'plus_plan' : ''}`}>
                                            <p>{lang === 0 ? '추가할 멤버' : 'Additional member'}</p>
                                            <div>
                                                <input 
                                                    className="member_plus"
                                                    type="text" 
                                                    placeholder={lang === 0 ? '인원수' : 'Number of members'}
                                                    maxLength={4}
                                                    name="member_plus"
                                                    onChange={numberInput}
                                                    value={myModelValue}
                                                />
                                                <span>{lang === 0 ? '인' : 'member'}</span>
                                            </div>
                                        </div>

                                        {inputErr == 1 && 
                                            <span 
                                                className="err_msg id" 
                                                style={{
                                                    marginTop: '-20px',
                                                    textAlign: 'right'
                                                }}
                                            >
                                                {lang === 0 ? '멤버를 입력해 주세요.' : 'Please enter the member.'}
                                            </span>
                                        }
                                    </>
                                }

                                {/* {plan_type == "Team" &&
                                    <div className={`use_member_box ${plan_plus ? 'plus_plan' : ''}`}>
                                        <p>{plan_plus ? '추가할' : '사용할'} 멤버</p>
                                        <div>
                                            <input 
                                                type="text" 
                                                placeholder="인원수"
                                                maxLength={4}
                                                name="model_people"
                                                onChange={numberInput}
                                            />
                                            <span>인</span>
                                        </div>
                                    </div>
                                } */}

                                {pay_card &&
                                    <div className="pay_card_box">
                                        <p>{lang === 0 ? '결제 카드' : 'Pay Card'}</p>
                                        <div>
                                            <img src={require("../../assets/icon/Card.svg").default} />
                                            <span>{mainCard?.cardName}</span>
                                        </div>
                                    </div>
                                }
                                {!plan_plus && planPopRadioValue !== 1 && // 기존 가격페이지에서 구매
                                    <div className="price_option">
                                        <p className="title">{lang === 0 ? '할인 적용' : 'Discount Applied'}</p>
                                        
                                        <div 
                                            className={`coupon_drop_box ${couponDrop ? 'on' : ''}`}
                                            onClick={() => {
                                                setCouponDrop(!couponDrop)
                                            }}
                                        >
                                            <p>{couponSelect}</p>

                                            {couponDrop &&
                                                <div className="coupon_drop_list">
                                                    {!useCoupon &&
                                                        <p
                                                            onClick={() => {
                                                                setCouponSelect(coupon_none);
                                                                setCouponErr(0);
                                                                setConponInputState(2);
                                                            }}
                                                        >
                                                            {coupon_none}
                                                        </p>
                                                    }

                                                    <p
                                                        onClick={() => {
                                                            setCouponSelect(coupon_input);
                                                            setCouponErr(0);
                                                            setConponInputState(0);
                                                            setCouponInputValue('');
                                                        }}
                                                    >
                                                        {coupon_input}
                                                    </p>
                                                    
                                                    {couponlists.map((x, i) => (
                                                        <p 
                                                            key={i}
                                                            onClick={() => {
                                                                setCouponSelect(x?.couponCode);
                                                                setCouponInputValue(x?.couponCode);
                                                                setCouponErr(0);
                                                                setConponInputState(2);
                                                            }}
                                                        >
                                                            {x?.couponCode}
                                                        </p>
                                                    ))}
                                                </div> 
                                            }
                                        </div>
                                        

                                        {/* {!notUseCoupon &&
                                            <div className="sale_comment">
                                                3개월간 20% 할인 적용됩니다.
                                            </div>
                                        } */}

                                        {couponErr == 1 && <span className="err_msg id" style={{ marginTop: '-4px' }}>{lang === 0 ? '쿠폰을 선택해 주세요.' : 'Please select a coupon.'}</span>}

                                        {couponInput &&
                                            <>
                                                <div className="coupon_input_box">
                                                    <input 
                                                        type="text"
                                                        className={`${couponInputState === 2 ? 'active' : ''}`}
                                                        name="couponinput"
                                                        placeholder={lang === 0 ? '쿠폰 코드 입력' : 'Enter Coupon Code'}
                                                        maxLength={20}
                                                        onChange={numberInput}
                                                        value={couponInputValue}
                                                        readOnly={couponInputState === 2}
                                                    />
                                                    
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            if(!couponInputValue) {
                                                                setConponInputState(1);
                                                            } else {
                                                                if(couponlists?.find(item => item?.couponCode === couponInputValue)){
                                                                    setConponInputState(2);
                                                                } else {
                                                                    setConponInputState(1);
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        {lang === 0 ? '등록' : 'Register'}
                                                    </button>
                                                </div>

                                                {couponInputState == 1 && <span className="err_msg id" style={{ marginTop: '-4px' }}>{lang === 0 ? '유효한 쿠폰 코드가 아닙니다.' : 'This is not a valid coupon code.'}</span>}
                                            </>
                                        }
                                        {couponInputState == 2 && 
                                            <>
                                                {couponSelect != coupon_none &&
                                                    <span className="err_msg id" style={{ color: '#0E6AF4', marginTop: '-4px' }}>
                                                        {lang === 0 ? '쿠폰이 정상적으로 등록되었습니다.' : 'The coupon has been successfully applied.'}
                                                    </span>
                                                }
                                            </>
                                        }

                                        {couponInputState == 4 && <span className="err_msg id" style={{ marginTop: '-4px' }}>{lang === 0 ? '쿠폰을 선택해 주세요.' : 'Please select a coupon.'}</span>}
                                    </div>
                                }
                                

                                <div className="amount_box">
                                    {plan_plus ? 
                                        <> {/* 쿠폰 페이지에서 결제 */}
                                            {/* <div className="amount_info0">
                                                <p>구독 금액(월)</p>
                                                <span className={`${!notUseCoupon ? 'on' : ''}`}>₩19,000</span>
                                            </div>

                                            <div className="amount_info1">
                                                <p>멤버(수량)</p>
                                                <span>5인</span>
                                            </div> */}
                                            <div className="amount_info0">
                                                <p>{lang === 0 ? '구독 금액(연)' : 'Annual Subscription Fee'}</p>
                                                <span className="">
                                                {(showWon ? '₩' : '$')}278,400
                                                </span>
                                            </div>

                                            {couponInputState === 2 &&
                                                <div className="amount_info0">
                                                    <p>{lang === 0 ? '쿠폰 적용 금액' : 'Discounted Amount'}</p>
                                                    <span className={`${!notUseCoupon ? 'on' : ''}`}>
                                                    {(showWon ? '₩' : '$')}{numFormat(proYear * (discounts/100))}
                                                    </span>
                                                </div>
                                            }

                                            <div className="amount_info1">
                                                <p>{lang === 0 ? '시트 수량' : 'Number of Seats'}</p>
                                                <span>{myModelValue}</span>
                                            </div>
                                        </>
                                        :
                                        <> {/* 가격 페이지에서 결제 */}
                                            <div className="amount_info0">
                                                <p>{lang === 0 ? <>구독 금액({planPopRadioValue === 1 ? '월' : '연'})</> : <>Subscription Fee({planPopRadioValue === 1 ? 'Month' : 'Year'})</> }</p>
                                                <span className="">
                                                
                                                    {plan_type === "Pro" &&
                                                        <>
                                                            {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth.toFixed(2))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear.toFixed(2))}`}
                                                        </>
                                                    }

                                                    {plan_type === "Art Pass" &&
                                                        <>
                                                            {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth.toFixed(2))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear.toFixed(2))}`}
                                                        </>
                                                    }

                                                    {plan_type === "All-In-One" &&
                                                        <>
                                                            {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth.toFixed(2))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear.toFixed(2))}`}
                                                        </>
                                                    }
                                                </span>
                                            </div>

                                            {couponInput ?
                                                <>
                                                    {couponInputState === 2 &&
                                                        <div className="amount_info0">
                                                            <p>{lang === 0 ? '쿠폰 적용 금액' : 'Coupon Applied Amount'}</p>
                                                            <span className={`${!notUseCoupon ? 'on' : ''}`}>
                                                                {plan_type === "Pro" &&
                                                                    <>
                                                                        {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100))}`}
                                                                    </>
                                                                }

                                                                {plan_type === "Art Pass" &&
                                                                    <>
                                                                        {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100))}`}
                                                                    </>
                                                                }

                                                                {plan_type === "All-In-One" &&
                                                                    <>
                                                                        {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100))}`}
                                                                    </>
                                                                }
                                                            </span>
                                                        </div>
                                                    }
                                                </>
                                                :
                                                <>
                                                    {!notUseCoupon &&
                                                        <div className="amount_info0">
                                                            <p>{lang === 0 ? '쿠폰 적용 금액' : 'Coupon Applied Amount'}</p>
                                                            <span className={`${!notUseCoupon ? 'on' : ''}`}>
                                                                {plan_type === "Pro" &&
                                                                    <>
                                                                        {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat((proMonth * (discounts/100)).toFixed(2))}` : `${(showWon ? '₩' : '$')}${numFormat((proYear * (discounts/100)).toFixed(2))}`}
                                                                    </>
                                                                }

                                                                {plan_type === "Art Pass" &&
                                                                    <>
                                                                        {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100))}`}
                                                                    </>
                                                                }

                                                                {plan_type === "All-In-One" &&
                                                                    <>
                                                                        {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100))}`}
                                                                    </>
                                                                }
                                                            </span>
                                                        </div>
                                                    }
                                                </>
                                            }

                                            {!licensePlus ? 
                                                <>
                                                {seetnotviewer === false &&
                                                <div className="amount_info1 sheet">
                                                    <p>{lang === 0 ? '시트 수량' : 'Number of Seats'}</p>
                                                    <input 
                                                        className="sheet"
                                                        type="text" 
                                                        placeholder="수량"
                                                        maxLength={4}
                                                        name="sheetnum"
                                                        onChange={numberInput}
                                                        value={sheetValue}
                                                    />
                                                </div>}
                                                </>
                                                :
                                                <div className="amount_info1 sheet">
                                                    <p>{lang === 0 ? '시트 수량' : 'Number of Seats'}</p>
                                                    <span>{myModelValue}</span>
                                                </div>
                                            }

                                            {inputErr == 1 && !licensePlus &&
                                                <span 
                                                    className="err_msg id" 
                                                    style={{
                                                        marginTop: '4px',
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    {lang === 0 ? '수량을 입력해 주세요.' : 'Please enter the quantity.'}
                                                </span>
                                            }

                                            <div className="amount_info1">
                                            </div>
                                        </>
                                    }

                                    <div className="amount_info2">
                                        <p>{lang === 0 ? '결제 금액' : 'Total Payment Amount '}</p>
                                        <b>
                                            {plan_plus &&
                                                <>
                                                    ${(showWon ? '₩' : '$')}{numFormat(278400 * (discounts/100) * myModelValue)}
                                                </>
                                            }

                                            {licensePlus ?
                                                <>
                                                    {plan_type === "Pro" &&
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat((proMonth * (discounts/100) * myModelValue).toFixed(2))}` : `${(showWon ? '₩' : '$')}${numFormat((proYear * (discounts/100) * myModelValue).toFixed(2))}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat((proMonth * myModelValue)?.toFixed(2))}` : `${(showWon ? '₩' : '$')}${numFormat((proYear * myModelValue).toFixed(2))}`}
                                                                </>
                                                            }
                                                        </>
                                                    }

                                                    {plan_type === "Art Pass" &&
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100) * myModelValue)}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * myModelValue)}`}
                                                                </>
                                                            }
                                                        </>
                                                    }

                                                    {plan_type === "All-In-One" &&
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100) * myModelValue)}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * myModelValue)}`}
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </>
                                                :
                                                <>
                                                    {plan_type === "Pro" &&
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat((proMonth * (discounts/100) * sheetValue).toFixed(2))}` : `${(showWon ? '₩' : '$')}${numFormat(((proYear - (proYear * (discounts/100))) * sheetValue).toFixed(2))}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat((proMonth * sheetValue).toFixed(2))}` : `${(showWon ? '₩' : '$')}${numFormat((proYear * sheetValue).toFixed(2))}`}
                                                                </>
                                                            }
                                                        </>
                                                    }

                                                    {plan_type === "Art Pass" &&
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * sheetValue)}` : `${(showWon ? '₩' : '$')}${numFormat((proYear-(proYear * (discounts/100))) * sheetValue)}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * sheetValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * sheetValue)}`}
                                                                </>
                                                            }
                                                        </>
                                                    }

                                                    {plan_type === "All-In-One" &&
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * sheetValue)}` : `${(showWon ? '₩' : '$')}${numFormat((proYear-(proYear * (discounts/100))) * sheetValue)}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * sheetValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * sheetValue)}`}
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </>
                                            }
                                        </b>
                                    </div>
                                </div>
                            </div>
                        :
                            <div className="pop_scroll_box">
                                {!useCoupon && !plan_plus &&
                                    <div className="price_option">
                                        <p className="title">{lang === 0 ? '청구 옵션' : 'Billing Options'}</p>

                                        <label className={`option_chk ${planPopRadioValue === 2 ? 'on' : ''}`} htmlFor="price_option3">
                                            <input 
                                                type="radio" 
                                                name="price_option" 
                                                id="price_option3"
                                                onChange={() => checkboxFunc(2)}
                                                checked={planPopRadioValue === 2}
                                            />
                                            <div className="price">
                                                <p>{lang === 0 ? '연 구독' : 'Annual Payment'}</p>
                                                <span>
                                                    <b style={{ marginRight: 5}}>{(showWon ? '' : 'USD ')}{proYear}{showWon ? lang === 0 ? '원' : 'KRW' : ''}</b> 
                                                    {/* {lang === 0 ? <>(월 기준 {numFormat((proYear/12).toFixed(2))}원)</> 
                                                    : 
                                                    <>({(showWon ? '' : 'USD ')}{numFormat((proYear/12).toFixed(2))} per month)</>}</span> */}
                                                    {lang === 0 ? <>(월 기준 {(showWon ? '' : 'USD ')}{numFormat((proYear/12).toFixed(2))}{showWon ? lang === 0 ? '원' : 'KRW' : ''})</> : <>({(showWon ? '' : 'USD ')}{numFormat((proYear/12).toFixed(2))} per month)</>}</span>
                                            </div>
                                        </label>
                                    </div>
                                }

                                {pay_card &&
                                    <div className="pay_card_box">
                                        <p>{lang === 0 ? '결제 카드' : 'Pay Card'}</p>
                                        <div>
                                            <img src={require("../../assets/icon/Card.svg").default} />
                                            <span>{mainCard?.cardName}</span>
                                        </div>
                                    </div>
                                }

                                {!plan_plus && // 기존 가격페이지에서 구매
                                    <div className="price_option">
                                        <p className="title">{lang === 0 ? '할인 적용' : 'Discount Applied'}</p>

                                        <div 
                                            className={`coupon_drop_box ${couponDrop ? 'on' : ''}`}
                                            onClick={() => {
                                                setCouponDrop(!couponDrop)
                                            }}
                                        >
                                            <p>{couponSelect}</p>

                                            {couponDrop &&
                                                <div className="coupon_drop_list">
                                                    {!useCoupon &&
                                                        <p
                                                            onClick={() => {
                                                                setCouponSelect(coupon_none);
                                                                setCouponErr(0);
                                                                setConponInputState(2);
                                                            }}
                                                        >
                                                            {coupon_none}
                                                        </p>
                                                    }

                                                    {/* <p
                                                        onClick={() => {
                                                            setCouponSelect(coupon_input);
                                                            setCouponErr(0);
                                                            setConponInputState(0);
                                                        }}
                                                    >
                                                        {coupon_input}
                                                    </p> */}
                                                    
                                                    {couponlists.map((x, i) => (
                                                        <p 
                                                            key={i}
                                                            onClick={() => {
                                                                setCouponSelect(x?.couponCode);
                                                                setCouponErr(0);
                                                                setConponInputState(2);
                                                            }}
                                                        >
                                                            {x?.couponCode}
                                                        </p>
                                                    ))}
                                                </div> 
                                            }
                                        </div>

                                        {/* {!notUseCoupon &&
                                            <div className="sale_comment">
                                                3개월간 20% 할인 적용됩니다.
                                            </div>
                                        } */}

                                        {couponErr == 1 && <span className="err_msg id" style={{ marginTop: '-4px' }}>{lang === 0 ? '쿠폰을 선택해 주세요.' : 'Please select a coupon.'}</span>}

                                        {couponInput &&
                                            <>
                                                <div className="coupon_input_box">
                                                    <input 
                                                        type="text"
                                                        className={`${couponInputState === 2 ? 'active' : ''}`}
                                                        name="couponinput"
                                                        placeholder={lang === 0 ? '쿠폰 코드 입력' : 'Enter Coupon Code'}
                                                        maxLength={20}
                                                        onChange={numberInput}
                                                        value={couponInputValue}
                                                        readOnly={couponInputState === 2}
                                                    />
                                                    
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            if(!couponInputValue) {
                                                                setConponInputState(1);
                                                            } else {
                                                                setConponInputState(2);
                                                            }
                                                        }}
                                                    >
                                                        {lang === 0 ? '등록' : 'Register'}
                                                    </button>
                                                </div>

                                                {couponInputState == 1 && <span className="err_msg id" style={{ marginTop: '-4px' }}>{lang === 0 ? '유효한 쿠폰 코드가 아닙니다.' : 'This is not a valid coupon code.'}</span>}
                                            </>
                                        }
                                        {couponInputState == 2 && 
                                            <>
                                                {couponSelect != coupon_none &&
                                                    <span className="err_msg id" style={{ color: '#0E6AF4', marginTop: '-4px' }}>
                                                        {lang === 0 ? '쿠폰이 정상적으로 등록되었습니다.' : 'The coupon has been successfully applied.'}
                                                    </span>
                                                }
                                            </>
                                        }

                                        {couponInputState == 4 && <span className="err_msg id" style={{ marginTop: '-4px' }}>{lang === 0 ? '쿠폰을 선택해 주세요.' : 'Please select a coupon.'}</span>}
                                    </div>
                                }

                                <div className="amount_box">
                                    <> {/* 할인 페이지에서 결제 */}
                                        <div className="amount_info0">
                                            <p>{lang === 0 ? <>구독 금액({planPopRadioValue === 1 ? '월' : '연'})</> : <>Subscription Fee({planPopRadioValue === 1 ? 'Month' : 'Year'})</> }</p>
                                            <span className="">
                                                {}
                                                {plan_type === "Pro" &&
                                                    <>
                                                        {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat((proMonth).toFixed(2))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear)}`}
                                                    </>
                                                }

                                                {plan_type === "Art Pass" &&
                                                    <>
                                                        {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear)}`}
                                                    </>
                                                }

                                                {plan_type === "All-In-One" &&
                                                    <>
                                                        {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear)}`}
                                                    </>
                                                }
                                            </span>
                                        </div>

                                        {couponInput ?
                                            <>
                                                {couponInputState === 2 &&
                                                    <div className="amount_info0">
                                                        <p>{lang === 0 ? '쿠폰 적용 금액' : 'Coupon Applied Amount'}</p>
                                                        <span className={`${!notUseCoupon ? 'on' : ''}`}>
                                                            {plan_type === "Pro" &&
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100))}`}
                                                                </>
                                                            }

                                                            {plan_type === "Art Pass" &&
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100))}`}
                                                                </>
                                                            }

                                                            {plan_type === "All-In-One" &&
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100))}`}
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                }
                                            </>
                                            :
                                            <>
                                                {!notUseCoupon &&
                                                    <div className="amount_info0">
                                                        <p>{lang === 0 ? '쿠폰 적용 금액' : 'Coupon Applied Amount'}</p>
                                                        <span className={`${!notUseCoupon ? 'on' : ''}`}>
                                                            {plan_type === "Pro" &&
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat((proMonth * (discounts/100)).toFixed(2))}` : `${(showWon ? '₩' : '$')}${numFormat((proYear * (discounts/100)).toFixed(2))}`}
                                                                </>
                                                            }

                                                            {plan_type === "Art Pass" &&
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100))}`}
                                                                </>
                                                            }

                                                            {plan_type === "All-In-One" &&
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100))}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100))}`}
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                }
                                            </>
                                        }

                                        {!licensePlus ? 
                                            <div className="amount_info1 sheet">
                                                <p>{lang === 0 ? '시트 수량' : 'Number of Seats'}</p>
                                                {plan_type === "Pro" ?
                                                <input 
                                                    className="sheet"
                                                    type="text" 
                                                    placeholder="수량"
                                                    maxLength={4}
                                                    name="sheetnum"
                                                    onChange={numberInput}
                                                    value={sheetValue}
                                                    readOnly={true}
                                                />
                                                :
                                                <input 
                                                    className="sheet"
                                                    type="text" 
                                                    placeholder="수량"
                                                    maxLength={4}
                                                    name="sheetnum"
                                                    onChange={numberInput}
                                                    value={sheetValue}
                                                />}
                                            </div>
                                            :
                                            <div className="amount_info1 sheet">
                                                <p>{lang === 0 ? '시트 수량' : 'Number of Seats'}</p>
                                                <span>{myModelValue}</span>
                                            </div>
                                        }

                                        {inputErr == 1 && !licensePlus &&
                                            <span 
                                                className="err_msg id" 
                                                style={{
                                                    marginTop: '4px',
                                                    textAlign: 'right'
                                                }}
                                            >
                                                {lang === 0 ? '수량을 입력해 주세요.' : 'Please enter the quantity.'}
                                            </span>
                                        }

                                        <div className="amount_info1">
                                        </div>
                                    </>

                                    <div className="amount_info2">
                                        <p>{lang === 0 ? '결제 금액' : 'Total Payment Amount '}</p>
                                        <b>
                                            {plan_plus &&
                                                <>
                                                    ${(showWon ? '₩' : '$')}{numFormat(278400 * (discounts/100) * myModelValue)}
                                                </>
                                            }

                                            {licensePlus ?
                                                <>
                                                    {plan_type === "Pro" &&
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100) * myModelValue)}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * myModelValue)}`}
                                                                </>
                                                            }
                                                        </>
                                                    }

                                                    {plan_type === "Art Pass" &&
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100) * myModelValue)}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * myModelValue)}`}
                                                                </>
                                                            }
                                                        </>
                                                    }

                                                    {plan_type === "All-In-One" &&
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100) * myModelValue)}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * myModelValue)}`}
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </>
                                                :
                                                <>
                                                    {plan_type === "Pro" &&
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat((proMonth * (discounts/100) * sheetValue).toFixed(2))}` : `${(showWon ? '₩' : '$')}${numFormat(((proYear-(proYear * (discounts/100))) * sheetValue).toFixed(2))}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat((proMonth * sheetValue).toFixed(2))}` : `${(showWon ? '₩' : '$')}${numFormat((proYear * sheetValue).toFixed(2))}`}
                                                                </>
                                                            }
                                                        </>
                                                    }

                                                    {plan_type === "Art Pass" &&
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * sheetValue)}` : `${(showWon ? '₩' : '$')}${numFormat((proYear-(proYear * (discounts/100))) * sheetValue)}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * sheetValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * sheetValue)}`}
                                                                </>
                                                            }
                                                        </>
                                                    }

                                                    {plan_type === "All-In-One" &&
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * sheetValue)}` : `${(showWon ? '₩' : '$')}${numFormat((proYear-(proYear * (discounts/100))) * sheetValue)}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * sheetValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * sheetValue)}`}
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </>
                                            }
                                        </b>
                                    </div>
                                </div>
                            </div>
                        }

                        {(buttonCancel || button || longButton) &&
                            <div className="popup_btn_box plan_model">
                                {free_text && <span>{lang === 0 ? '30일 이후 청구되며, 최소 3개월 구독을 유지해야 합니다.' : 'You will be charged after 30 days and must maintain a minimum subscription of 3 months. '}</span>}
                                {licensePlus && 
                                    <p  
                                        style={{ marginBottom: '20px', fontSize: '16px' }}
                                    >
                                        {lang === 0 ?
                                        <>
                                        {planPopRadioValue === 1 ? '2025.05 06' : '2026.05 06'}
                                        일부터는
                                        {!notUseCoupon ?
                                            <>
                                                {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100) * myModelValue)}`}
                                            </>
                                            :
                                            <>
                                                {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * myModelValue)}`}
                                            </>
                                        }
                                        이 추가됩니다.                                        
                                        </>
                                        :
                                        <>
                                        An additional 
                                        {!notUseCoupon ?
                                            <>
                                                {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * (discounts/100) * myModelValue)}`}
                                            </>
                                            :
                                            <>
                                                {planPopRadioValue === 1 ? `${(showWon ? '₩' : '$')}${numFormat(proMonth * myModelValue)}` : `${(showWon ? '₩' : '$')}${numFormat(proYear * myModelValue)}`}
                                            </>
                                        }                                        
                                        will be charged from {planPopRadioValue === 1 ? '2025.05 06' : '2026.05 06'}
                                        </>
                                        }

                                    </p>
                                }

                                {buttonCancel && (
                                    <button
                                        className="button_cancel"
                                        onClick={() => {
                                            if (func === "setRightFunc") {
                                                setFunction();
                                            } else {
                                                if(cancelFunc) cancelFunc();
                                                dispatch(close());
                                            }
                                        }}
                                    >
                                        {buttonCancel}
                                    </button>
                                )}
                                {button && (
                                    <button
                                        className="button_success"
                                        onClick={() => {
                                            if (func === "setRightFunc") {
                                                dispatch(close());
                                            } else {
                                                setFunction();
                                            }
                                        }}
                                    >
                                        {button}
                                    </button>
                                )}
                                {longButton && (
                                    <button
                                        className="button_success long"
                                        onClick={() => {
                                            if(plan_plus || licensePlus) {
                                                if(couponInput) {
                                                    if(!couponInputValue) {
                                                        setConponInputState(1);
                                                        return;
                                                    }

                                                    if(couponInputState != 2 && planPopRadioValue !== 1) {
                                                        setConponInputState(4);
                                                        return;
                                                    }

                                                    if(!myModelValue) {
                                                        setInputErr(1);
                                                        return;
                                                    } 
                                                } else {
                                                    if(couponInputState != 2 && planPopRadioValue !== 1) {
                                                        setConponInputState(4);
                                                        return;
                                                    } 
                                                    
                                                    if(!myModelValue) {
                                                        setInputErr(1);
                                                        return;
                                                    } 
                                                }

                                                if(couponInputState == 2 && myModelValue){
                                                    setCouponErr(0)
                                                    setMaxWidthCut('400px');
                                                    setStepPayPopup(2);
                                                }
                                                
                                            } else {
                                                
                                                if(couponInput) {
                                                    if(!couponInputValue) {
                                                        setConponInputState(1);
                                                        return;
                                                    }

                                                    if(couponInputState != 2 && planPopRadioValue !== 1) {
                                                        setConponInputState(4);
                                                        return;
                                                    }

                                                    if(!sheetValue) {
                                                        setInputErr(1);
                                                        return;
                                                    } 
                                                } else {
                                                    
                                                    if(couponInputState != 2 && planPopRadioValue !== 1) {
                                                        setConponInputState(4);
                                                        return;
                                                    }

                                                    if(!sheetValue) {
                                                        setInputErr(1);
                                                        return;
                                                    } 
                                                }
                                                console.log('????', couponInputValue, couponInputState, planPopRadioValue, myModelValue);

                                                if(couponInputState == 2 && myModelValue){
                                                    setCouponErr(0)
                                                    setMaxWidthCut('400px');
                                                    setStepPayPopup(2);
                                                }
                                            }
                                        }}
                                    >
                                        {longButton}
                                    </button>
                                )}
                            </div>
                        }
                    </>
                }

                {stepPayPopup == 2 &&
                    <>
                        {!plan_plus &&
                            <div className="title step2">
                                <span className="model_name">UModeler X {plan_type}</span>
                            </div>
                        }

                        {/* {free_plan &&
                            <div className="free_comment step2">
                                <span>무료 이용 기간 30일</span>
                            </div>
                        } */}

                        <div className={`amount_option_box ${lang === 0 ? '' : 'en'}`}>
                            {!plan_plus ?
                                <>
                                    {plan_type !== "Pro" &&
                                    <div className="info1">
                                        <p>{lang === 0 ? '시트 수량' : 'Number of Seats'}</p>
                                        <span>
                                            {licensePlus ? myModelValue : sheetValue}
                                        </span>
                                    </div>}

                                    <div className="info1">
                                        <p>{lang === 0 ? '청구 옵션' : 'Billing Options'}</p>
                                        <span>
                                            {plan_type === "Pro" &&
                                                <>
                                                    {planPopRadioValue === 1 ?
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {lang === 0 ? '월간 결제' : 'Monthly Payment'} {`${(showWon ? '₩' : '$')}${numFormat((proMonth * (discounts/100) * sheetValue).toFixed(2))}`}/{lang === 0 ? '월' : 'Month'}
                                                                </>
                                                                :
                                                                <>
                                                                    {lang === 0 ? '월간 결제' : 'Monthly Payment'} {`${(showWon ? '₩' : '$')}${numFormat((proMonth * sheetValue).toFixed(2))}`}/{lang === 0 ? '월' : 'Month'}
                                                                </>
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {lang === 0 ? '연 구독' : 'Annual Payment'} {`${(showWon ? '₩' : '$')}${numFormat(((proYear-(proYear * (discounts/100))) * sheetValue).toFixed(2))}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {lang === 0 ? '연 구독' : 'Annual Payment'} {`${(showWon ? '₩' : '$')}${numFormat(((proYear) * sheetValue).toFixed(2))}`}
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </>
                                            }
                                            
                                            {plan_type === "Art Pass" &&
                                                <>
                                                    {planPopRadioValue === 1 ?
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {lang === 0 ? '월간 결제' : 'Monthly Payment'} {`${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * sheetValue)}`}/월
                                                                </>
                                                                :
                                                                <>
                                                                    {lang === 0 ? '월간 결제' : 'Monthly Payment'} {`${(showWon ? '₩' : '$')}${numFormat(proMonth * sheetValue)}`}/월
                                                                </>
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {lang === 0 ? '연 구독' : 'Annual Payment'} {`${(showWon ? '₩' : '$')}${numFormat((proYear-(proYear * (discounts/100))) * sheetValue)}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {lang === 0 ? '연 구독' : 'Annual Payment'} {`${(showWon ? '₩' : '$')}${numFormat(proYear * sheetValue)}`}
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </>
                                            }

                                            {plan_type === "All-In-One" &&
                                                <>
                                                    {planPopRadioValue === 1 ?
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {lang === 0 ? '월간 결제' : 'Monthly Payment'} {`${(showWon ? '₩' : '$')}${numFormat(proMonth * (discounts/100) * sheetValue)}`}/월
                                                                </>
                                                                :
                                                                <>
                                                                    {lang === 0 ? '월간 결제' : 'Monthly Payment'} {`${(showWon ? '₩' : '$')}${numFormat(proMonth * sheetValue)}`}/월
                                                                </>
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            {!notUseCoupon ?
                                                                <>
                                                                    {lang === 0 ? '연 구독' : 'Annual Payment'} {`${(showWon ? '₩' : '$')}${numFormat((proYear-(proYear * (discounts/100))) * sheetValue)}`}
                                                                </>
                                                                :
                                                                <>
                                                                    {lang === 0 ? '연 구독' : 'Annual Payment'} {`${(showWon ? '₩' : '$')}${numFormat(proYear * sheetValue)}`}
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </>
                                            }
                                        </span>
                                    </div>

                                    <div className="info1">
                                        <p>{lang === 0 ? '구독 시작일' : 'Subscription start date'}</p>
                                        <span>{moment().format('YYYY-MM-DD')}</span>
                                    </div>
                                    <div className="info1">
                                        <p>{lang === 0 ? '다음 결제일' : 'Next Billing Date'}</p>
                                        <span>{moment().add(planPopRadioValue === 1 ? 30 : 1, planPopRadioValue === 1 ? 'days' : 'years').format('YYYY-MM-DD')}</span>
                                    </div>
                                    <div style={{ width: '100%' }}>
                                        {lang === 0 ?
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', width: '100%'}}>
                                                <div style={{ textAlign: 'left', fontSize: 12, maxWidth: 265}}>
                                                ㆍ최종 결제 및 환불 정책은 <a href="https://help.xsolla.com/ko" target="_blank" style={{ textDecoration: 'underline', fontWeight: 700}}>Xsolla</a>의 정책을 따릅니다.
                                                </div>
                                                <div style={{ textAlign: 'left', fontSize: 12, maxWidth: 265}}>
                                                ㆍ결제 요청하며 <a href="/terms/ko" target="_blank" style={{ textDecoration: 'underline', fontWeight: 700}}>이용 약관</a>에 동의합니다.
                                                </div>
                                            </div>
                                        :
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', width: '100%'}}>
                                                <div style={{ textAlign: 'left', fontSize: 12, maxWidth: 430}}>
                                                ㆍ The final payment and refund policy follows <a href="https://help.xsolla.com/en" target="_blank" style={{ textDecoration: 'underline', fontWeight: 700}}>Xsolla</a>'s terms and conditions.
                                                </div>
                                                <div style={{ textAlign: 'left', fontSize: 12, maxWidth: 430}}>
                                                ㆍ By proceeding with the payment, you agree to the <a href="/terms/en" target="_blank" style={{ textDecoration: 'underline', fontWeight: 700}}>Terms of Use.</a>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', fontSize: 12, color: 'red' }}>
                                        {planPopRadioValue === 1 ?
                                            <>
                                                {!notUseCoupon ?
                                                    <>
                                                        {lang === 0 ? `다음 결제일에 ${(showWon ? '' : 'USD')} ${numFormat((proMonth * (discounts/100) * sheetValue).toFixed(2))}${(showWon ? '원' : '')} 으로 정상 청구됩니다.` 
                                                        : 
                                                        `${(showWon ? '' : 'USD')} ${numFormat((proMonth * (discounts/100) * sheetValue).toFixed(2))} will be charged on the next billing date.`}
                                                    </>
                                                    :
                                                    <>
                                                        {lang === 0 ? `다음 결제일에 ${(showWon ? '' : 'USD')} ${numFormat((proMonth * sheetValue).toFixed(0))}${(showWon ? '원' : '')} 으로 정상 청구됩니다.` 
                                                        : 
                                                        `${(showWon ? '' : 'USD')} ${numFormat((proMonth * sheetValue).toFixed(2))} will be charged on the next billing date.`}
                                                    </>
                                                }
                                            </>
                                            :
                                            <>
                                                {!notUseCoupon ?
                                                    <>
                                                        {lang === 0 ? `다음 결제일에 ${(showWon ? '' : 'USD')} ${numFormat(((PriceProYearsale) * sheetValue).toFixed(2))}${(showWon ? '원' : '')} 으로 정상 청구됩니다.` 
                                                        : 
                                                        `${(showWon ? '' : 'USD')} ${numFormat((PriceProYearsale) * sheetValue)} will be charged on the next billing date.`}
                                                    </>
                                                    :
                                                    <>
                                                        {lang === 0 ? `다음 결제일에 ${(showWon ? '' : 'USD')} ${numFormat(((PriceProYearsale) * sheetValue).toFixed(2))}${(showWon ? '원' : '')} 으로 정상 청구됩니다.` 
                                                        : 
                                                        `${(showWon ? '' : 'USD')} ${numFormat(((PriceProYearsale) * sheetValue).toFixed(2))} will be charged on the next billing date.`}
                                                    </>
                                                }
                                            </>
                                        }
                                        
                                    </div>
                                </>
                                :
                                <>
                                    <div className="info1">
                                        <p>{lang === 0 ? '청구 옵션' : 'Billing Options'}</p>
                                        <span>{lang === 0 ? '연 구독' : 'Annual Payment'}</span>
                                    </div>

                                    <div className="info1">
                                        <p>{lang === 0 ? '구독 시작일' : 'Subscription start date'}</p>
                                        <span>{moment().format('YYYY-MM-DD')}</span>
                                    </div>

                                    <div className="info1">
                                        <p>{lang === 0 ? '다음 결제일' : 'Next billing date'}</p>
                                        <span>2026-06-07</span>
                                    </div>

                                    <p className="last_comment">{lang === 0 ? '결제하시겠습니까?' : 'Would you like to start your subscription?'}</p>
                                    {/* <div className="popup_use_coupon_text">
                                        <span>다음 청구월부터 적용됩니다.</span>
                                        <p className="date">2024-07-07</p>
                                        <p className="comment">쿠폰을 사용하시겠습니까?</p>
                                    </div> */}
                                </>
                                
                            }
                            
                        </div>

                        <div 
                            className="popup_btn_box"
                            style={{ width: '100%' }}
                        >
                            <button
                                className="button_cancel"
                                onClick={() => {
                                    if (func === "setRightFunc") {
                                        setFunction();
                                    } else {
                                        if(cancelFunc) cancelFunc();
                                        dispatch(close());
                                    }
                                }}
                            >
                                {lang === 0 ? '닫기' : 'Close'}
                            </button>
                            
                            <button
                                className="button_success"
                                onClick={() => {
                                    if(!couponSale) {
                                        setStepPayPopup(3);
                                        setMaxWidthCut('300px');
                                    } else {
                                        payOk();
                                    }
                                }}
                            >
                                {lang === 0 ? '네' : 'Ok'}
                            </button>
                        </div>
                    </>
                }

                {stepPayPopup == 3 &&
                    <>
                        <div className="last_msg">
                        {lang === 0 ? '결제하시겠습니까?' : 'Would you like to start your subscription?'}
                        </div>

                        <div 
                            className="popup_btn_box"
                            style={{ width: '100%' }}
                        >
                            <button
                                className="button_cancel"
                                onClick={() => {
                                    if (func === "setRightFunc") {
                                        setFunction();
                                    } else {
                                        if(cancelFunc) cancelFunc();
                                        dispatch(close());
                                    }
                                }}
                            >
                                {lang === 0 ? '취소' : 'Close'}
                            </button>
                            
                            <button
                                className="button_success"
                                onClick={() => {
                                    payOk();
                                }}
                            >
                                {lang === 0 ? '확인' : 'Confirm'}
                            </button>
                        </div>
                    </>
                }
                </div>
            </div>

            <ToastContainer
                position="top-center"
                className={`popup_toast`}
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
